// extracted by mini-css-extract-plugin
export var blue = "_28-f";
export var brand = "_28-b";
export var darkGrey = "_28-e";
export var disabled = "_28-4";
export var disabledSubtle = "_28-5";
export var error = "_28-6";
export var green = "_28-g";
export var grey = "_28-d";
export var icon = "_28-0";
export var inherit = "_28-a";
export var lightGrey = "_28-c";
export var orange = "_28-i";
export var pink = "_28-k";
export var primary = "_28-1";
export var purple = "_28-l";
export var red = "_28-j";
export var secondary = "_28-2";
export var success = "_28-9";
export var tertiary = "_28-3";
export var warning = "_28-7";
export var warningSecondary = "_28-8";
export var white = "_28-m";
export var yellow = "_28-h";